<div class="expandable-case-div" #split>
    <div class="left-view-div">
        <app-case-details [application]="application"></app-case-details>
    </div>
    <div 
        #gutter
        class="adjuster"
        role="separator"
        aria-orientation="vertical"
        tabindex="0"
    >⋮</div>
    <div class="right-view-div">
        <app-case-documents [application]="application" [submittedDocuments]="submittedDocuments"></app-case-documents>
    </div>
</div>
